import React from 'react';
import BottomNav from '../component/BottomNav';

const TermsAndConditions = () => {
    return (
        <>
            <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-7 mb-9">
                <h1 className="text-center text-4xl font-bold text-[#54BD95] mb-6">Terms and Conditions</h1>

                {/* Content Sections */}
                <div className="space-y-6">
                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">1. ID Proof and Photo Submission</h2>
                        <p className="text-lg text-gray-700">
                            Tenants must provide valid identification proof (Aadhar card), a recent photograph, and details of their occupation at the time of agreement.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">2. Compliance with Society Rules</h2>
                        <p className="text-lg text-gray-700">
                            Tenants are required to abide by all rules and regulations established by the residential society.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">3. Notice Period for Vacating</h2>
                        <p className="text-lg text-gray-700">
                            The property owner reserves the right to request the tenant to vacate the premises, subject to a one-month notice period.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">4. Liability for Physical Damages</h2>
                        <p className="text-lg text-gray-700">
                            Tenants are responsible for any physical damage to the property during their stay and will be liable for covering the cost of repairs.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">5. Clearance of Dues upon Departure</h2>
                        <p className="text-lg text-gray-700">
                            Prior to vacating the premises, tenants must settle all outstanding dues and charges.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">6. Service Scope</h2>
                        <p className="text-lg text-gray-700">
                            Our responsibility is limited to providing the room, villa, or flat. After moving in, all society rules and regulations will be managed by the society itself.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">7. Prohibition of Illegal Activities</h2>
                        <p className="text-lg text-gray-700">
                            Any illegal activities conducted on the premises may result in legal actions taken by the society.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-[#333]">8. Service Charge Payment</h2>
                        <p className="text-lg text-gray-700">
                            Tenants are required to pay the agreed-upon service charges before moving in.
                        </p>
                    </section>

                    <section>
                        <h3 className="text-2xl font-semibold text-[#333]">9. Contact Us</h3>
                        <p className="text-lg text-gray-700">
                            For any inquiries, please reach out to us at:
                        </p>
                        <ul className="list-disc list-inside text-lg text-gray-700">
                            <li><strong>Email:</strong> info@placezioestate.com</li>
                            <li><strong>Phone:</strong> +91 8318150076</li>
                            {/* <li><strong>Address:</strong> [Insert Physical Address]</li> */}
                        </ul>
                    </section>
                </div>
            </div>
            <BottomNav />
        </>
    );
};

export default TermsAndConditions;
